import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTestimonial() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >



                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                “After installing solar with Yogesh Solar Energy, my electricity bill has reduced drastically. The team was professional and completed the installation on time.”
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mr. Premchand Gupta</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                “Excellent service and smooth process from consultation to installation. Highly recommended for anyone planning to switch to solar energy.”
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mr. Sukhnandan Gupta</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                “The team guided us properly about government subsidies and helped us save money. Very trustworthy company!”
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mr. Vidyasagar Mishra</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                “Quality products and great after-sales support. Always ready to help whenever needed.”
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mr. Ramsanehi Kushwaha</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                “Best decision we made for our home. Clean energy and huge savings every month!”
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mis Kalpana Devi Vishwakarma</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                "Customer support bahut achha hai. Har query ka quick response milta hai. Solar lagwane ke baad life easy ho gayi hai."
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4> Mr. Pramod Vishwakarma</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                "Yogesh Solar Energy ki team ne mujhe sahi guidance di aur best system suggest kiya. Installation ke baad koi issue nahi aaya. Fully satisfied!"
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mr. Naveen Kumar</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" ><div className="testimonial-item">
                        <div className="testimonial-quote">
                            <div className="testimonial-rate">
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                            </div>
                            <div className="testimonial-quote-icon">
                                <img src="assets/img/icon/quote.svg" alt />
                            </div>
                            <p>
                                "Affordable pricing aur excellent service. Ab power cuts ka tension nahi hai. Thank you Yogesh Solar Energy team!"
                            </p>
                        </div>
                        <div className="testimonial-content">
                            <div className="testimonial-author-img">
                                <img src="./assets/yog/Profile.png" alt />
                            </div>
                            <div className="testimonial-author-info">
                                <h4>Mis. Bhagvati Devi</h4>
                                <p>Customer</p>
                            </div>
                        </div>
                    </div></div>
                </SwiperSlide>
                




            </Swiper>
        </>
    );
}
